import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./FeatureSection.css";
import { FaChalkboardTeacher, FaCertificate, FaLaptopCode } from "react-icons/fa";
import featureImage from "../Component/Cpit3.jpg"; // ✅ your original right-side image

function FeatureSection() {
  return (
    <section className="feature-section">
      <div className="container py-5">
        <div className="row align-items-center">
          {/* Left Content */}
          <div className="col-lg-7">
            <div className="section-title mb-4">
              <h6>WHY CHOOSE US?</h6>
              <h1>Why You Should Start Learning with CPIT?</h1>
              <p>
                At CPIT, we don’t just provide courses — we create career opportunities. Our programs are designed to meet the needs of students, professionals, and job seekers who wish to upgrade their skills and build a strong foundation for their future.
              </p>
            </div>

            {/* Feature 1 */}
            <div className="d-flex align-items-start mb-4">
              <div className="icon-box bg-danger text-white me-3">
                <FaChalkboardTeacher size={26} />
              </div>
              <div>
                <h5>Skilled Instructors</h5>
                <p className="text-muted mb-0">
                  Our trainers are highly qualified professionals with years of industry and teaching experience. They provide personalized guidance, hands-on training, and mentorship to ensure every student learns effectively and confidently.
                </p>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="d-flex align-items-start mb-4">
              <div className="icon-box bg-danger text-white me-3">
                <FaCertificate size={26} />
              </div>
              <div>
                <h5>International Certificate</h5>
                <p className="text-muted mb-0">
                  We offer globally recognized certifications that enhance your credibility and open doors to career opportunities both in India and abroad. Each program follows international standards to help you stay ahead in the global job market.
                </p>
              </div>
            </div>

            {/* Feature 3 */}
            <div className="d-flex align-items-start">
              <div className="icon-box bg-danger text-white me-3">
                <FaLaptopCode size={26} />
              </div>
              <div>
                <h5>Online Classes</h5>
                <p className="text-muted mb-0">
                  CPIT offers flexible learning modes — attend classes online or in-person at our centers. Our blended learning approach ensures accessibility, convenience, and continuous support, no matter where you are.
                </p>
              </div>
            </div>
          </div>

          {/* Right Image - feature.jpg */}
          <div className="col-lg-5 text-center mt-5 mt-lg-0">
            <div className="position-relative feature-img-wrapper">
              <img
                src={featureImage}
                alt="Feature"
                className="img-fluid rounded shadow-lg feature-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeatureSection;
